import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';
import {FeatureRolloutName, FeatureRollouts} from 'common/report/util/feature-sampling';

export function canUseMultiAttribution(currentProject?: CurrentProject | ProjectDetails): boolean {
  // Always return true for projects with feature flag enabled
  if (currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttribution)) {
    return true;
  }
  return FeatureRollouts[FeatureRolloutName.MultiAttribution].isEnabled(currentProject);
}
